import type { ReactNode, RefObject } from 'react';
import styles from './style.module.scss';

export interface StackedLayoutTemplateProps {
  /** Ref for the container */
  containerRef?: RefObject<HTMLDivElement>;
  /** Main stacked content */
  children: ReactNode;
  /** Fixed/sticky element at bottom */
  stickyFooter?: ReactNode;
  /** Additional CSS class */
  className?: string;
}

/**
 * StackedLayoutTemplate - Vertical stacked layout with optional sticky footer
 * 
 * Atomic Design: Template
 * - Single column vertical stack
 * - Optional sticky footer (fixed to bottom)
 * 
 * @example
 * ```tsx
 * <StackedLayoutTemplate stickyFooter={<ActionBar />}>
 *   <Header />
 *   <Content />
 *   <Footer />
 * </StackedLayoutTemplate>
 * ```
 */
export function StackedLayoutTemplate({
  containerRef,
  children,
  stickyFooter,
  className,
}: StackedLayoutTemplateProps) {
  return (
    <div 
      ref={containerRef}
      className={`${styles.container} ${className || ''}`}
    >
      {children}
      {stickyFooter}
    </div>
  );
}

export default StackedLayoutTemplate;
